export default "__VITE_ASSET__51a11029__"